import React from 'react';
import { Result, Button } from 'antd';
import { MobileOutlined, DesktopOutlined } from '@ant-design/icons';

function MobileNotSupported() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{ 
        background: 'white', 
        borderRadius: '12px', 
        padding: '40px', 
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        maxWidth: '1200px',
        width: '100%',
        textAlign: 'center'
      }}>
        <Result
          icon={<MobileOutlined style={{ color: '#ff4d4f', fontSize: '64px' }} />}
          title="Mobile Not Supported"
          subTitle={
            <div style={{ color: '#666', lineHeight: '1.6' }}>
              <p style={{ marginBottom: '16px' }}>
                This application is designed for desktop and tablet devices only.
              </p>
              <p style={{ marginBottom: '24px' }}>
                For the best experience, please access this application from a desktop computer or tablet.
              </p>
              <div style={{ 
                background: '#f6f8fa', 
                padding: '16px', 
                borderRadius: '8px',
                border: '1px solid #e1e4e8'
              }}>
                <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#24292e' }}>
                  Recommended devices:
                </p>
                <ul style={{ 
                  margin: '0', 
                  paddingLeft: '20px', 
                  textAlign: 'left',
                  color: '#586069'
                }}>
                  <li>Desktop computer (Windows, Mac, Linux)</li>
                  <li>Tablet (iPad, Android tablet)</li>
                  <li>Laptop with screen width ≥ 768px</li>
                </ul>
              </div>
            </div>
          }
          extra={
            <div style={{ marginTop: '24px' }}>
              <Button 
                type="primary" 
                size="large"
                icon={<DesktopOutlined />}
                onClick={() => window.location.reload()}
                style={{ 
                  marginRight: '12px',
                  background: '#1890ff',
                  borderColor: '#1890ff'
                }}
              >
                Try Again
              </Button>
              <Button 
                
                size="large"
                onClick={() => window.open('mailto:qhuy.dev@gmail.com', '_blank')}
                style={{ 
                  borderColor: '#d9d9d9',
                  color: '#666',
                  marginTop: '5px'
                }}
              >
                Contact Support
              </Button>
            </div>
          }
        />
        
        <div style={{ 
          marginTop: '32px', 
          padding: '16px', 
          background: '#fff7e6', 
          borderRadius: '8px',
          border: '1px solid #ffd591'
        }}>
          <p style={{ 
            margin: '0', 
            color: '#d46b08', 
            fontSize: '14px',
            fontWeight: '500'
          }}>
            💡 <strong>Tip:</strong> If you're on a mobile device, try rotating to landscape mode or use a desktop browser for the full experience.
          </p>
        </div>
      </div>
    </div>
  );
}

export default MobileNotSupported;